import React from 'react';
import { useEffect } from "react";
import { useMap, GeoJSON } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";


const drawOptions = {
    snappable: false,
    allowSelfIntersection: false,
    continueDrawing: true,
    tooltips: false
}

const defaultMessage = "The parcel must have a maximum of 100 hectares.";
let insertInit = {
    "family": '',
    "variety": ''
}
const ManualClusteringGeoman = ({
    zonedGeom, setZonedGeom
}) => {
    const leafletContainer = useMap();
    const groupRef = React.useRef();
    const { t } = useTranslation();
    const [openAlert, setOpenAlert] = React.useState({ open: false, message: defaultMessage });

    useEffect(() => {

        leafletContainer.pm.setGlobalOptions({ pmIgnore: false, layerGroup: groupRef.current });
        leafletContainer.pm.addControls({  
            position: 'topleft',  
            drawCircle: false,  
          });  

        leafletContainer.on("pm:create", (e) => {
            if (e.layer && e.layer.pm) {
                var area = L.GeometryUtil.geodesicArea(e.layer.getLatLngs()[0]);
                if (area / 10000 <= 100) {
                    //groupRef.current.addLayer(e.layer);

                    let geoJson = e.layer.toGeoJSON();

                    const shape = e;
                    console.log(e);

                    // enable editing of circle
                    shape.layer.pm.enable();

                    console.log(`object created: ${shape.layer.pm.getShape()}`);
                    // console.log(leafletContainer.pm.getGeomanLayers(true).toGeoJSON());
                    /* leafletContainer.pm
                        .getGeomanLayers(true)
                        .bindPopup("i am whole")
                        .openPopup();
                    leafletContainer.pm
                        .getGeomanLayers()
                        .map((layer, index) => layer.bindPopup(`I am figure N° ${index}`)); */
                    shape.layer.on("pm:edit", (e) => {
                        let geoJson = e.layer.toGeoJSON();
                        
                        console.log(leafletContainer.pm.getGeomanLayers(true).toGeoJSON());
                    });
                } else {
                    // enable editing of circle
                    e.layer.remove();
                    setOpenAlert({ ...openAlert, open: true });

                }
            }
        })



        leafletContainer.on("pm:remove", (e) => {
            console.log("object removed");
            // console.log(leafletContainer.pm.getGeomanLayers(true).toGeoJSON());
        });

        //leafletContainer.pm.enableDraw('Polygon', drawOptions);

        return () => {
            leafletContainer.pm.setGlobalOptions({ pmIgnore: true, layerGroup: groupRef.current });
        };

    }, []);

    /* React.useEffect(() => {
        if (clearLastVertex) {
            leafletContainer.pm.Draw.Polygon._removeLastVertex();
            console.log(leafletContainer.pm.Draw.Polygon)
            setClearLastVertex(false)
        }
    }, [clearLastVertex])


    React.useEffect(() => {
        if (clearDraw) {
            leafletContainer.pm.Draw.disable();
            leafletContainer.pm.enableDraw('Polygon', drawOptions);
            setClearDraw(false)
        }
    }, [clearDraw])

    React.useEffect(() => {
        if (addedParcels.length === 0) {
            groupRef.current.clearLayers()   // remove old data
        } else if (addedParcels.length > 0 && groupRef.current.getLayers().length > addedParcels.length) {
            groupRef.current.clearLayers()   // remove old data
            addedParcels.forEach(element => {
                groupRef.current.addLayer(element.layer);
                element.layer.pm.enable();
            });


        } else if (addedParcels.length > 0 && groupRef.current.getLayers().length === 0 && openAddParcel.mode !== 'sigpac') {
            addedParcels.forEach(element => {
                const geom = element.layer._layers[Object.keys(element.layer._layers)[0]]
                var area = L.GeometryUtil.geodesicArea(geom.getLatLngs()[0]);
                if (area / 10000 <= 100) {
                    groupRef.current.addLayer(element.layer);
                    element.layer.pm.enable();
                }
                else setOpenAlert({ open: true, message: "Some parcels have not been included as they exceed 100 hectares." });
            });
            try {
                leafletContainer.fitBounds(groupRef.current.getBounds())
            } catch (error) {
                console.error(error);
            }
            leafletContainer.pm.enableDraw('Polygon', drawOptions);

        }
    }, [addedParcels.length]) */


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({ open: false, message: defaultMessage });
    };

    return (<>
        <GeoJSON ref={groupRef} data={zonedGeom} name="Manual Zones"></GeoJSON>
        <Snackbar
            open={openAlert.open}
            autoHideDuration={6000}
            onClose={handleClose}>
            <Alert severity="warning" onClose={handleClose}>
                {t(openAlert.message)}
            </Alert>
        </Snackbar>
    </>);
};

export default ManualClusteringGeoman;
